





define(['./search'], function(searchModel) {
    'use strict';

    return function(data) {
        if (!(data.batchItems instanceof Array)) {
            return null;
        }
        return data.batchItems.map(function(batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error};
            } else {
                return searchModel(batchItem.response);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./model/search/batchSearch.js